<template>
  <v-dialog
    v-model="dialog"
    max-width="500"
    :persistent="persistent"
  >
    <v-card>
      <v-card-title class="card-title">
        <v-layout wrap>
          <v-flex xs12>
            <v-layout
              xs12
              justify-end
              align-center
            >
              <v-icon
                large
                class="clickable"
                @click="agree()"
              >
                clear
              </v-icon>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text class="pb-0">
        <p class="f-1 mb-0">
          {{ text }}
        </p>
      </v-card-text>
      <v-card-actions>
        <v-layout
          align-center
          class="my-2"
          justify-center
        >
          <v-btn
            color="sz_violet"
            @click="agree"
          >
            {{ $t('buttons.ok') }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    name: 'InfoModal',
    props: {
        text: {
            type: String,
            required: true
        },
        visible: {
            type: Boolean,
            default: false
        },
        persistent: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
            dialog: false
        };
    },
    watch: {
        visible (val) {
            this.dialog = val;
        },
        dialog () {
            if (!this.dialog) {
                this.$emit('close', false);
            }
        }
    },
    created () {
        this.dialog = this.visible;
    },
    methods: {
        agree () {
            this.dialog = false;
            this.$emit('close', false);
        }
    }
};
</script>

<style scoped></style>
